<div class="modal-body">
    <div class="content">
      <div class="content__main">
        <div class="top">
          <h4 translate>equipment.modals.add-equipment.title</h4>
          <button type="button" class="close" aria-label="Close" (click)="close()">
            <i class="icon-small-close"></i>
          </button>
        </div>
        <span class="step">Step: {{currentStep}}</span>
        <div class="form" [formGroup]="form">
            <div *ngIf="currentStep == 1" class="row">
                <div class="form-group col-12 col-lg-6">
                    <label for="mac-address" translate>equipment.modals.add-equipment.form.mac-address.label</label>
                    <div class="vox-input-group vox-input-group_dense" [ngClass]="{
                      'vox-input-group_invalid': isFieldValid('mac_address')
                    }">
                        <input class="vox-text-field" type="text" formControlName="mac_address" id="mac-address">
                        <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
                        <span *ngIf="form.get('mac_address').errors && form.get('mac_address').errors.required" class="vox-input-group__error-message" translate>equipment.modals.add-equipment.form.mac-address.error-required</span>
                        <span *ngIf="form.get('mac_address').errors && form.get('mac_address').errors.pattern" class="vox-input-group__error-message" translate>equipment.modals.add-equipment.form.mac-address.error-pattern</span>
                    </div>
                </div>
                <div class="form-group col-12 col-lg-6">
                    <label for="model" translate>equipment.modals.add-equipment.form.model.label</label>
                    <div ngbDropdown class="vox-dropdown-input" placement="bottom">
                        <button
                          id="phone-model-dropdown"
                          ngbDropdownToggle
                          >
                          {{form.value.model}}
                        </button>
                        <div ngbDropdownMenu aria-labelledby="phone-model-dropdown">
                          <button ngbDropdownItem
                          class="dropdown__item"
                          type="button"
                          *ngFor="let model of models; let idx = index"
                          (click)="selectModel(model)">
                          {{model}}
                          </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div *ngIf="currentStep == 1" class="form-group col-12">
                    <label for="company" translate>equipment.modals.add-equipment.form.company.label</label>
                    <div class="vox-input-group_dense">
                      <gdp-company-search formControlName="company"></gdp-company-search>
                    </div>
                </div>
                <div *ngIf="currentStep == 2" class="form-group col-12">
                  <div *ngIf="form.get('model').value === 'AIR'" class="vox-inline-message vox-inline-message_light-grey" style="margin-bottom: 1rem;">
                    <div>
                      <i class="icon-small-info"></i>
                      <span [innerHTML]="'equipment.modals.add-equipment.ipui-disclaimer' | translate"></span>
                    </div>
                  </div>
                  <div *ngIf="form.get('model').value === 'AIR'" class="form-group">
                    <label for="ipui" translate>equipment.modals.add-equipment.form.ipui.label</label>
                    <div class="vox-input-group vox-input-group_dense" [ngClass]="{
                      'vox-input-group_invalid': isFieldValid('ipui')
                      }">
                      <input class="vox-text-field" type="text" id="ipui" formControlName="ipui" [placeholder]="'equipment.modals.add-equipment.form.ipui.placeholder' | translate"/>
                      <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
                      <span *ngIf="form.get('ipui').errors && form.get('ipui').errors.required" class="vox-input-group__error-message" translate>equipment.modals.add-equipment.form.ipui.error-required</span>
                      <span *ngIf="form.get('ipui').errors && form.get('ipui').errors.pattern" class="vox-input-group__error-message" translate>equipment.modals.add-equipment.form.ipui.error-pattern</span>
                    </div>
                  </div>
                  <label for="company-user" translate>equipment.modals.add-equipment.form.company-user.label</label>
                  <div ngbDropdown class="vox-dropdown-input" placement="bottom">
                    <div *ngIf="selectedUser">
                      <button class="vox-btn dropdown_btn"
                        id="equipment-user-dropdown"
                        ngbDropdownToggle
                      >
                        {{selectedUser.firstName}} {{selectedUser.lastName}} ({{selectedUser.extension}})
                      </button>
                    </div>
                    <span ngbDropdownToggle class="vox-btn dropdown_btn" *ngIf="!selectedUser" translate>equipment.modals.add-equipment.form.company-user.not-selected</span>
                    <div ngbDropdownMenu aria-labelledby="equipment-user-dropdown">
                      <button ngbDropdownItem
                      class="dropdown__item"
                      type="button"
                      (click)="selectUser(null)"
                      translate>
                      equipment.modals.add-equipment.form.company-user.not-selected
                    </button>
                      <button ngbDropdownItem
                        class="dropdown__item"
                        type="button"
                        *ngFor="let user of users; let idx = index"
                        (click)="selectUser(user)"
                        translate>
                        {{user.firstName}} {{user.lastName}} ({{user.extension}})
                      </button>
                      <span class="empty-list" *ngIf="users.length === 0" translate>equipment.modals.add-equipment.form.company-user.empty-list</span>
                    </div>
                  </div>
                </div>
            </div>
            <div class="buttons-conrainer">
              <button class="vox-btn vox-btn-secondary-dark-grey" *ngIf="currentStep == 1" (click)="close()" translate>equipment.modals.add-equipment.form.buttons.close</button>
              <button class="vox-btn vox-btn-secondary"
                [disabled]="!isFormValid()" *ngIf="currentStep == 1"
                (click)="clickNext()"
                [ladda]="loadingUsers"
                data-spinner-color="grey"
                data-style="zoom-in">
                <span translate>equipment.modals.add-equipment.form.buttons.next</span>
              </button>
              <button class="vox-btn vox-btn-secondary-dark-grey"
                *ngIf="currentStep == 2"
                (click)="clickBack()" translate>
                equipment.modals.add-equipment.form.buttons.back
              </button>
              <button class="vox-btn vox-btn-secondary"
                *ngIf="currentStep == 2"
                (click)="addEquipment()"
                [disabled]="!isFormValid()"
                [ladda]="loadingCreate"
                data-spinner-color="grey"
                data-style="zoom-in">
                <span translate>equipment.modals.add-equipment.form.buttons.add</span>
              </button>
            </div>
        </div>
      </div>
    </div>
</div>
